<div class="counts">
  <sc-flex *ngIf="counts?.total > 0">
    <div class="bar total">
      {{'total ' | translate: ['tmc.visit.overview.total-count', translationService.language]}}
      {{counts?.total}}
    </div>
    <div class="bar planned" [style.flex-grow]="counts?.planned" *ngIf="counts?.planned > 0">
      {{'planned' | translate: ['tmc.visit.overview.planned-count', translationService.language]}}
      {{counts?.planned}}
    </div>
    <div class="bar inProcessing" [style.flex-grow]="counts?.inProcessing" *ngIf="counts?.inProcessing > 0">
      {{'in progress' | translate: ['tmc.visit.overview.in-progress-count', translationService.language]}}
      {{counts?.inProcessing}}
    </div>
    <div class="bar waitingForPull" [style.flex-grow]="counts?.waitingForPull" *ngIf="counts?.waitingForPull > 0">
      {{'waiting for pull' | translate: ['tmc.visit.overview.waiting-for-pull-count', translationService.language]}}
      {{counts?.waitingForPull}}
    </div>
    <div class="bar finished" [style.flex-grow]="counts?.finished" *ngIf="counts?.finished > 0">
      {{'finished' | translate: ['tmc.visit.overview.finished-count', translationService.language]}}
      {{counts?.finished}}
    </div>
    <div class="bar paused" [style.flex-grow]="counts?.paused" *ngIf="counts?.paused > 0">
      {{'paused' | translate: ['tmc.visit.overview.paused-count', translationService.language]}}
      {{counts?.paused}}
    </div>
    <div class="bar vehicles" [style.flex-grow]="counts?.vehicles" *ngIf="counts?.vehicles > 0">
      {{'vehicles' | translate: ['tmc.visit.overview.vehicles-count', translationService.language]}}
      {{counts?.vehicles}}
    </div>
  </sc-flex>
</div>